<template>
  <div class="finance-page">
    <header class="finance-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('moneybag.withdrawRecord') }}</h1>
      <button
        type="button"
        class="header-action"
        @click="$router.push('/moneybag')"
      >
        <van-icon name="filter-o" />
      </button>
    </header>

    <main class="finance-main">
      <section
        v-if="listShow"
        class="empty-card"
      >
        <van-empty :description="$t('item.noData')" />
      </section>

      <section
        v-if="data && data.length"
        class="record-list"
      >
        <article
          v-for="(item, index) in data"
          :key="item.id || item.time || index"
          class="record-card"
        >
          <div class="record-head">
            <div class="record-title">
              <strong>{{ item[lang] }}</strong>
              <span>{{ formatBrowserTime(item.time) }}</span>
            </div>
            <b
              class="record-price"
              :class="item.type =='1'?'':'del'"
            >
              <template v-if="item.type =='1'">
                {{ utils_moneyMark() }}{{ item.money }}
              </template>
              <template v-else>
                -{{ utils_moneyMark() }}{{ item.money }}
              </template>
            </b>
          </div>
          <p
            v-if="item.remark!=''"
            class="record-memo"
          >
            {{ $t('cash.remark') }}: {{ item.remark }}
          </p>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
        Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "WithdrawRecord",
        data() {
            return {
                lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/funds',{
                reason_id: 2
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = r.data.money;
                this.mymoney = r.data.mymoney;
                this.userName = r.data.username;
            })
        },
        methods: {
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
.finance-page {
    min-height: 100vh;
    background: #f4f5fb;
    color: #061429;
}

.finance-header {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f7f8fd;
}

.finance-header h1 {
    margin: 0;
    color: #202637;
    font-size: 14px;
    font-weight: 500;
    line-height: 50px;
}

.back-btn,
.header-action {
    position: absolute;
    top: 10px;
    width: 28px;
    height: 28px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #071426;
    font-size: 22px;
}

.back-btn {
    left: 8px;
}

.header-action {
    right: 14px;
    color: #3e4656;
    font-size: 20px;
}

.finance-main {
    padding: 16px 16px 88px;
}

.empty-card,
.record-card {
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.record-card {
    padding: 16px 18px;
}

.record-card + .record-card {
    margin-top: 12px;
}

.record-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
}

.record-title {
    min-width: 0;
}

.record-title strong,
.record-price {
    display: block;
    overflow: hidden;
    color: #050b18;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-title span {
    display: block;
    margin-top: 4px;
    overflow: hidden;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.record-price {
    flex: 0 0 auto;
    max-width: 42%;
    margin-left: 12px;
    color: #ff4551;
    text-align: right;
}

.record-price.del {
    color: #38bf62;
}

.record-memo {
    margin: 12px 0 0;
    padding-top: 12px;
    border-top: 1px solid #edf0f6;
    color: #8b93a3;
    font-size: 12px;
    line-height: 18px;
}
</style>
